import React, { useState } from 'react';
import { Rnd } from 'react-rnd';
import { PiArrowFatLinesDownFill } from 'react-icons/pi';

const DynamicRuler = ({ orientation, size, onLinePositionChange }) => {
  const [dragPosition, setDragPosition] = useState(48);

  const rulerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    width: orientation === 'portrait' ? size.width : size.height,
    margin: '30px auto',
    borderBottom: '1px solid #ccc',
    position: 'relative',
  };

  const renderTicks = () => {
    const majorTickHeight = 15;
    const minorTickHeight = 8;
    const totalMarks = 10;
    const subMarks = 5;
    const tickWidth = 100 / (totalMarks * subMarks);

    let ticks = [];

    for (let i = 0; i <= totalMarks * subMarks; i++) {
      const isMajorTick = i % subMarks === 0;

      ticks.push(
        <div key={i} style={{
          flex: `${tickWidth}%`,
          textAlign: 'center',
          position: 'relative',
          borderLeft: isMajorTick ? '2px solid #000' : '1px solid #000',
        }}>
          {isMajorTick && (
            <span style={{
              position: 'absolute',
              bottom: '-20px',
              left: '50%',
              transform: 'translateX(-50%)',
            }}>
              {i / subMarks}
            </span>
          )}

          {!isMajorTick && (
            <span style={{
              position: 'absolute',
              bottom: '-5px',
              left: '50%',
              transform: 'translateX(-50%)',
              fontSize: '5px',
            }}>
              |
            </span>
          )}
        </div>
      );
    }
    return ticks;
  };

  const handleDrag = (e, data) => {
    e.stopPropagation();
    setDragPosition(data.x);
    onLinePositionChange(data.x);
  };

  return (
    <div className="dynamic-ruler mt-3" style={{ position: 'relative', ...rulerStyle }}>
      {renderTicks()}

      <Rnd
        default={{ x: dragPosition, y: 0, width: 25, height: 30 }}
        bounds="parent"
        enableResizing={false}
        onDrag={(e, data) => handleDrag(e, data)}
        style={{ cursor: 'pointer', position: 'absolute', top: '-10px' }}
      >
        <PiArrowFatLinesDownFill size={22} color="#4285f4ed" />
      </Rnd>
    </div>
  );
};

export default DynamicRuler;
